<script>
import Layout from "../../layouts/main";
//import appConfig from "@/app.config";
//import countTo from 'vue-count-to';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import BannerApi from "@/services/banner-api";
import ItemsApi from "@/services/items-api";

export default {
  /*page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },*/
  components: {
    Layout,//countTo
  },
  data() {
    return {

      counterVisible: false,
      keyCounterVisible:0,
      categories:null,

      iconsVisible: false,

      bannerList: [],
      icons: [
        { imgSrc: 'car-3-svgrepo-com', altText: 'default.icons.1.altText', text: 'default.icons.1.text' },
        { imgSrc: 'family-of-3-whole-body-svgrepo-com', altText: 'default.icons.2.altText', text: 'default.icons.2.text' },
        { imgSrc: 'plane-svgrepo-com', altText: 'default.icons.3.altText', text: 'default.icons.3.text' },
        { imgSrc: 'tray-dish-svgrepo-com', altText: 'default.icons.4.altText', text: 'default.icons.4.text' }
      ],

      isBannerTableBusy: false,
      mediaFeatures: [
      {
        id: "1",
        icon: "icon_1",
        alt: "users-2-svgrepo-com",
        title: "default.mediaFeatures.1.title",
        description: "default.mediaFeatures.1.description"
      },
      {
        id: "2",
        icon: "icon_2",
        alt: "qr-code-interactive",
        title: "default.mediaFeatures.2.title",
        description: "default.mediaFeatures.2.description"
      },
      {
        id: "3",
        icon: "icon_3",
        alt: "target-2-svgrepo-com",
        title: "default.mediaFeatures.3.title",
        description: "default.mediaFeatures.3.description"
      },
      {
        id: "4",
        icon: "icon_4",
        alt: "data-folder-svgrepo-comP",
        title: "default.mediaFeatures.4.title",
        description: "default.mediaFeatures.4.description"
      },
      {
        id: "5",
        icon: "icon_5",
        alt: "recycling-recycle",
        title: "default.mediaFeatures.5.title",
        description: "default.mediaFeatures.5.description"
      }
      ],



      counterItems: [
        {
          alt: 'bag',
          width: '70px',
          icon: 'bag-w.svg',
          moreThanText: 'ourPartner.moreThan',
          endVal: 100000,
          duration: 3000,
          title: 'ourPartner.bag',
          subTitle: 'ourPartner.distributed',
          perDay: 'ourPartner.perDay'
        },
        {
          alt: 'bread',
          width: '70px',
          icon: 'bread.svg',
          moreThanText: 'ourPartner.moreThan',
          endVal: 500,
          duration: 4000,
          title: 'ourPartner.partners',
          subTitle: 'ourPartner.intunisia',
          perDay: ''
        },
        {
          alt: 'capsules',
          width: '70px',
          icon: 'capsules.svg',
          moreThanText: 'ourPartner.moreThan',
          endVal: 3,
          duration: 4000,
          title: 'ourPartner.cibles',
          subTitle: 'ourPartner.ciblesPer',
          perDay: ''
        }
      ],


      newItems: [],




      


    };
  },

  computed: {
    windowWidth() {
      return window.innerWidth;
    },
  },

  watch:{

    iconsVisible(newValue){
      if(newValue){
      this.observeIcons()
      }
    },

    counterVisible(newValue) {
      if (newValue) {
        this.keyCounterVisible ++
      }
    }
  },

  mounted() {
    this.findBanner(this.windowWidth);
    this.getNewItems()
    this.getAllSection()
  },

  methods: {

    getNewItems(){
      ItemsApi.getNewItems()
      .then(result => {
        if(result){
          this.newItems= result
        }
      })
    },

    getAllSection(){
        ItemsApi.getAllSection().then(
            result =>{
                this.categories = result 
            }
        )
    },


    findBanner(windowWidth) {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(windowWidth).then((result) => {
        this.bannerList = result;
        
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

  }
};
</script>

<template>
  <Layout>

    <!-- Main Banners -->
    <div class="row pt-xl-0 " style="background:#9c9cd1c7;" >
      <!-- <div class="col-xl-9 col-sm-12 col-md-8" > -->
      <div class="col-12" >
        <div class="p-0" >
            <b-carousel
              style="box-shadow:0 2px 6px 0 rgb(0 0 0 / 8%);"
                img-width="1920"
                img-height="400" 
                :interval="6000"
               
                :controls="false"
                :indicators="false"
                :no-hover-pause="false"
                :no-touch="false"
                :fade="true">

                <b-carousel-slide
                          style="width:1920px; min-height:650px;" 
                          img-blank img-alt="Blank Image " 
                          img-width="1900"
                img-height="400" 
                          v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                  <!-- <p class="text-secondary">
                    caption="Restez à l'écoute!" 
                    Les publicitées seront disponibles prochainement
                  </p> -->

                </b-carousel-slide> 

                <b-carousel-slide v-for="banner in bannerList" :key="banner.id" >
                  <template #img>
                    <div class="banner-overlay" ></div>
                    <img :src="'/api/banner/get/' + banner.generatedName" alt="Banner Image" class="banner-image" width="100%" height="100%" >
                  </template>
                

                  <div>

                  

                  </div>

                </b-carousel-slide>
                
                <div  class="carousel-caption text-left d-none d-md-block">
                   
                    <h1 class="d-md-none d-lg-block font-weight-bold banner-title text-white text-uppercase text-center " style="font-size:3rem !important;"><span class="text-white">APS PACKAGING</span><sup>®</sup></h1>
                    <h1 class="d-lg-none d-md-block font-weight-bold banner-title text-white text-uppercase text-center " style="font-size:1.5rem !important;"><span class="text-white">APS PACKAGING</span><sup>®</sup></h1>
                    
                    <h1 class="d-md-none d-lg-block text-white text-center mt-4 banner-title" > {{ $t('default.bannerTitle') }} </h1>
                    <h1 class="d-lg-none d-md-block text-white text-center mt-4 banner-title" style="font-size:1.6rem !important;"> {{ $t('default.bannerTitle') }} </h1>

                  <h2 class="d-md-none d-lg-block text-primary text-center pt-xl-5 mt-5 mb-4 banner-title-white " style="font-size:2rem !important;">
                    {{ $t('default.bannerSubTitle1') }}
                  </h2>

                  <h2 class="d-md-none d-lg-block text-primary font-weight-bold text-center pt-0 banner-title-white" style="font-size:2rem !important;">
                    {{ $t('default.bannerSubTitle2') }}
                  </h2>

                  <h2 class="d-lg-none d-md-block text-primary font-weight-bold text-center pt-3 banner-title-white" style="font-size:1.2rem !important;">
                    {{ $t('default.bannerSubTitle1') }} {{ $t('default.bannerSubTitle2') }}
                  </h2>

                    <div class="mt-4 text-center">
                    <a class="pr-3" href="/demarrer-experience">
                        <b-button variant="success" style="padding: 10px 26px; letter-spacing:3px; box-shadow:0px 4px 6px rgba(0, 0, 0, 0.1);" class="font-weight-bold text-center text-uppercase font-size-24">
                        Démarrer l'expérience
                        </b-button>
                    </a>    
                    </div>
                </div>
                
              
            </b-carousel>



        </div>
      </div>


    </div>


      <div  class="row text-left pt-4 p-3 d-md-none bg-light justify-content-center">
          <div class="col-12 text-center">
            <img src="@/assets/images/logo.png" class="d-inline d-sm-none mt-1 ml-2 text-center " alt height="60" />
            <img src="@/assets/images/logo.png" class="d-none d-sm-inline ml-sm-5  pl-sm-5 text-center" alt height="120" />
          </div>

          <div class="col-12 text-center mt-3">
            <h1 class="d-inline d-sm-none font-weight-bold banner-title-mobile text-uppercase  mt-4 text-center " style="font-size:1.5rem !important;">APS PACKAGING<sup>®</sup></h1>
            <h1 class="d-none d-sm-inline font-weight-bold banner-title-mobile text-uppercase  mt-sm-5 pt-sm-2 text-center" style="font-size:2.5rem !important;">APS PACKAGING<sup>®</sup></h1>
          </div>

          <div class="col-12 text-center">
            <h3 class="d-block d-sm-none col-12 text-center mt-4 banner-title-mobile" style="font-size:1.4rem !important;">{{ $t('default.bannerTitle') }}</h3>
            <h3 class="d-none d-sm-block col-12 text-center mt-4 banner-title-mobile" style="font-size:2.6rem !important;">{{ $t('default.bannerTitle') }}</h3>
          </div>

        <h2 class="col-12 text-center font-weight-bold  mt-3 mb-2 banner-title-mobile" style="max-width: 100%;">
          {{ $t('default.bannerSubTitle1') }}{{ $t('default.bannerSubTitle2') }}
        </h2>

       

        <div class="col-12 mt-4 mb-4 text-center ">
          <a class="d-flex  justify-content-center" href="/demarrer-experience">
              <b-button variant="success" style="padding: 10px 26px; letter-spacing:3px; box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);" 
              class="d-block d-sm-none mt-2 font-weight-bold text-center  text-uppercase font-size-16">Démarrer l'expérience</b-button> 
              <b-button variant="success" style="padding: 10px 26px; letter-spacing:3px; box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);" 
              class="d-none d-sm-block mt-2 font-weight-bold text-center  text-uppercase font-size-16">Démarrer l'expérience</b-button> 
          </a>    
        </div>

      </div>


      <!-- NOUVEAUX MODELES -->
      <div class="mt-5 home-page-80-width ">

        <div class="row mt-5 pt-4">
          <div class="col-12">
              <h2 class="d-none d-md-block font-weight-bold text-dark text-uppercase" style="font-size:2.3rem !important;">Nouveaux modèles</h2>
              <h2 class="d-none d-sm-block d-md-none font-weight-bold text-dark text-uppercase" style="font-size:2rem !important;">Nouveaux modèles</h2>
              <h2 class="d-block d-sm-none font-weight-bold text-dark text-uppercase" style="font-size:1.2rem !important;">Nouveaux modèles</h2>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12">
            <div class="scrollable">
              <div v-for="(newItem, index) in newItems" :key="index">
                  <router-link :to="{ path:'/sac-personnalise' +newItem.url }">
                    <div class="img-category-wrapper">
                      <img
                          v-bind:src="'/api/image/get/' + newItem.image"
                        alt="Image produit" class="img-category"
                      />
                    </div>
                    <div class="text-dark font-weight-bold mt-3 mb-3 font-size-15">
                        {{ newItem.title }}
                      </div>
                  </router-link>
              </div>
            </div>
          </div>
        </div>

      </div>



    <!-- PERSONNALISATION -->
<div class="mt-5 pt-2">
  <div class="container mt-5 mb-5 pt-4 ">
    <div class="row m-3 m-sm-0">
      <div class="col-12 text-center">
        <h2 class="text-dark text-uppercase" >
          Créer, <strong>personnaliser</strong> et configurer votre emballage
        </h2>
        <h6 class="text-dark text-center mx-auto mt-4 px-2" style=" max-width:90%;">
          Utiliser notre <strong>outil de personnalisation</strong> qui vous permet de créer 
          et de commander votre emballage en quelques clics !
        </h6>

        <div class="row mt-4 align-items-center">
          <div class="col-md-6 col-12 text-center mb-4 mb-md-0">
            <img src="@/assets/images/modelDefalutScreen.png" alt style="filter: brightness(1.1) contrast(1.05); max-width:100%; height:auto;" />
          </div>

          <div class="col-md-6 col-12">
            <div class="p-3 p-md-4">
              <p class="text-justify text-dark font-size-18" style="line-height: 1.5;">
                Notre outil de personnalisation 2D vous permet de créer facilement des sacs personnalisés selon vos envies. En quelques clics, 
                vous pouvez ajouter vos propres images, logos, adresses, numéros de téléphone et bien plus encore. 
              </p>

              <p class="text-justify text-dark font-size-18 mt-4" style="line-height: 1.5;">
                Une large sélection de modèles préconçus est également disponible pour vous inspirer ou servir de base à votre création. 
              </p>

              <div class="mt-5 text-center">
                <a class="pr-3" href="/demarrer-experience">
                  <b-button variant="primary" style="letter-spacing:2px;" class="font-weight-bold text-uppercase font-size-18 p-3">
                    Personnaliser vos Sacs
                  </b-button>
                </a>    
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

      <!-- CATEGORIES -->
      <div class="mt-4 pt-2 pb-5 bg-light">
      <div class="container mt-5 ">
        <div class="row m-3 m-sm-0">
          <div class="col-12">
            <h2 class="font-weight-bold text-primary text-center ">Choisir votre univers de sacs</h2>
          </div>
        </div>

        <div class="row mt-5 pb-5 m-3 m-sm-0">
          <div class="col-12">
            <div class="row"  >
          <div v-for="(category, index) in categories" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-5 px-3 category-box d-flex justify-content-center">         
          
            <router-link :to="{ path: '/sac-personnalise/'+ category.seoName}" class="text-decoration-none w-100">
              <div class="d-flex justify-content-center align-items-center" style="height: 200px; overflow: hidden;">            
                <img v-bind:src="'/api/image/get/' + category.image" alt="Image produit" style="max-height: 100%; max-width: 100%; object-fit: contain;"/>
              </div>

              <div class="text-primary text-center font-weight-bold font-size-20 mt-3">
                {{ category.name }}
              </div>

              <div class="text-dark text-center mt-2 font-size-16 hide-description-default">
                {{ category.description }}
              </div>

              <div class="text-center mt-3 mb-5">
                <b-button variant="outline-primary" style="letter-spacing:2px;" class="font-weight-bold text-uppercase font-size-14">
                  Sélectionner
                </b-button>
              </div>

            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


       <!-- 5 points section -->
    <div class="pt-4 text-center bg-white ">
      
      <div class="pt-5 text-primary font-weight-bold m-3 m-sm-0" style="font-size:2.5rem;">
        {{$t("default.title")}}
      </div>

     

    </div>

    <div class="bg-white pt-md-5 pt-md-5 pt-3 pb-5 ">
          <div ref="mediaFeaturesSection" class="header-60-width row pt-md-4 pt-1 text-center justify-content-center ">
            <div 
              v-for="(feature, index) in mediaFeatures" 
              :key="feature.id"  
              class="col-md-4 col-12 mb-4 mt-4 pr-4 pl-4 fadeInUp" 
              :style="{ animationDelay: (index * 0.05) + 's' }"
              ref="mediaFeatureElements"
            >
              <img 
                :alt="feature.alt" 
                class="mb-2" 
                v-if="feature.icon" 
                :src="require('@/assets/images/' + feature.icon + '.png')" 
                height="70px"
              > 
              <h4 class=" mt-3 mb-2 font-weight-bold text-primary text-uppercase">{{ $t(feature.title) }}</h4>
              <p class="mt-2 text-dark font-size-14 text-center">{{ $t(feature.description) }}</p>
            </div>
        </div>

    </div>
      






      <div style="min-height: 100px;"></div>


  </Layout>
</template>

<style scoped>

@media (min-width: 768px) {
  .container {
    max-width: 70%;
  }
}


.banner-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    mix-blend-mode: multiply;
    background-blend-mode: multiply;

    background: #2E469D42;
    z-index: 20;
}

.banner-title-white {
  font-size:3rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 8px #fff; 
  font-weight: 700;
}

.banner-title {
  font-size:3rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.6); 
  font-weight: 700;
}




/* Mobile Version */

.banner-title-dark {
  font-size:3rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px #121212; font-weight: 700;
}
.banner-title-mobile {
  color : #01219A ;
  font-size:2rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px #fff; 
  font-weight: 700;
}


@media (max-width: 575px) { 
  .banner-title-mobile {
    font-size:1.1rem;
  }
}


.carousel-caption {
  position: absolute;
  top: 48%; 
  transform: translateY(-50%);
  z-index: 2;
}

@media (max-width: 767px) {
  .carousel-caption {
    position: absolute;
    padding-left: 5%;
    top: 30%;
    left: 0;
    transform: translateY(-50%);
    z-index: 2;
  }
}

.left-border {
  border-left: 3px solid #2E469D ;
  padding-left: 10px;
}


.category-box:hover {
  background: #FFF;
  box-shadow: 1px 4px 16px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

.hide-description-default {
  display: none;
}

.category-box:hover .hide-description-default {
  display: block;
}

.header-60-width,
.sub-title-60-width {
  max-width: 80%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-60-width,
  .sub-title-60-width {
      max-width: 70%;
  }
}
.separator-line {
  width: 15%;
  height: 4px;
  background-color: #2E469D ; /*#f7d584 ;*/
  border: none;
  margin: auto;
}

.sub-title-60-width {
  margin: 30px auto 0;
  color: #f7d584;
}


.img-category-wrapper {
  width: 200px;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
}

.img-category {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 1s ease;
}

.img-category:hover {
  transform: scale(1.08);
}

@media (min-width: 768px) {
  .banner-image {
   min-height: 600px  !important; 
  }
}


@media (max-width: 767px) { 
  .banner-image {
    height: 300px  !important;
  }
}

</style>


